import Api from "./base/api-base";

export default class templateApi {
  // 費目テンプレート一覧取得
  list() {
    return Api.get({
      endpoint: Api.endpoint.template,
    });
  }

  // 費目テンプレート登録
  store (params) {
    return Api.post({
      endpoint: Api.endpoint.template,
      params: params
    });
  }

  // 費目テンプレート取得
  info (id) {
    return Api.get({
      endpoint: Api.endpoint.template,
      id: id,
    });
  }

  // 費目テンプレート更新
  update (id, params) {
    return Api.post({
      endpoint: Api.endpoint.template,
      id: id,
      params: params
    });
  }

  // 費目テンプレート削除
  delete(id) {
    return Api.delete({
      endpoint: Api.endpoint.template,
      id: id,
    });
  }
}
